import { Button } from '@progress/kendo-react-buttons';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { GridToolbar } from '@progress/kendo-react-grid';
import { TabStrip, TabStripTab } from '@progress/kendo-react-layout';
import algoliasearch from 'algoliasearch';
import Body from 'commons/card/Body';
import CollapsableCard from 'commons/card/CollapsableCard';
import Blockquote from 'commons/status/Blockquote';
import React, { useCallback, useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import CategorieItem from './components/CategorieItem';
import CategorieItemRmv from './components/CategorieItemRmv';


export default function AlgoliaCategorie() {
  const Client = algoliasearch(process.env.REACT_APP_ID, process.env.REACT_APP_KEY);
  const Write_Client = algoliasearch(process.env.REACT_APP_ID, process.env.REACT_APP_WRITE_KEY);
  const [banner, setBanner] = useState('prod_categories');
  const Index_Write = Write_Client.initIndex(banner);
  const [files, setFiles] = useState([]);
  const [indices, setIndices] = useState(['tanguay_prod', 'tanguay_prod_en']);
  const [bannersIndices, setBannersIndices] = useState([]);
  const [selected, setSelected] = useState(0);
  const [banners, setBanners] = useState([]);
  const [filterBanners, setFilterBanners] = useState(banners);
  const [loading, setIsLoading] = useState(undefined);



  const sortFunction = (a, b) => {
    if (a.added !== undefined && b.added !== undefined) {
      var dateA = new Date(a.added).getTime();
      var dateB = new Date(b.added).getTime();
      return dateA > dateB ? 1 : -1;
    }
    return a > b;
  };

  const remove = (e) => {
    let copy = files.concat();
    let index = copy.findIndex((g) => g.path === e);
    copy.splice(index, 1);
    setFiles(copy);
  };

  const handleSelect = (e) => {
    setSelected(e.selected);
  };

  const resetBannersData = (lst) => {
    setBanners(lst);
    setFilterBanners(lst);
  };

  const updateCaching = () => {
    let ids = banners.map(e => e.objectID);
    fetch(
      `https://fn-adf.azurewebsites.net/api/DeleteV2/${banner}?code=H6lUK05z7dKicm9K3aLzXuYAE_eR-hC7ZPwbFg1NEB_vAzFuikeH3Q==`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(ids),
      }
    ).then(() => alert("Cache updated"));
  };

  const update = async (form) => {
    setIsLoading(form.objectID)
    const objectToSave = {
      texte_color: form.texte_color,
      title: form.title,
      src: form.src,
      description: form.description,
      from: form.dateDebut.toISOString().slice(0, 10).replaceAll('-', '/'),
      to: form.dateLimite.toISOString().slice(0, 10).replaceAll('-', '/'),
      objectID: form.objectID
    };

    await Index_Write.partialUpdateObject(objectToSave).wait();
    const rest = await Index_Write.search('', { hitsPerPage: 1000 });
    resetBannersData(rest.hits);
    setIsLoading(undefined);
  };

  const deleteBanner = async (objectID) => {
    setIsLoading(objectID);
    await Index_Write.deleteObject(objectID).wait();
    const rest = await Index_Write.search('', { hitsPerPage: 1000 });
    resetBannersData(rest.hits);
    setIsLoading(undefined);
  };

  const onDrop = useCallback(
    (acceptedFiles) => {
      acceptedFiles.forEach((file) => {
        const reader = new FileReader();
        reader.onload = () => {
          file.bin = reader.result.split(',')[1];
          let newFiles = [...files];
          setFiles(newFiles.concat(acceptedFiles));
        };
        reader.readAsDataURL(file);
      });
    },
    [files]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  const save = async (form) => {
    setIsLoading(form.path);
    const addBannerToCatalogAlgolia = await fetch(
      `https://3d-viewer-api.azurewebsites.net:443/api/addBannerToCatalogAlgolia/triggers/manual/invoke?api-version=2020-05-01-preview&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=FKPl1BeujN1vIKYfGUrpVXrMTzSqfA2X92NOJsggBHg`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ filename: form.path, base64String: form.bin }),
      }
    );
    const addBannerToCatalogAlgoliaJson =
      await addBannerToCatalogAlgolia.json();

    const objectToSave = {

      "categories.lvl0": form.all ? 'catégorie' : form.categories,
      image: `https://cdn.tanguay.ca/userfiles/images/${addBannerToCatalogAlgoliaJson.filename}`,
      texte_color: form.texte_color,
      title: form.title,
      src: form.src,
      created_at: form.created_at,
      description: form.description,
      from: form.dateDebut.toISOString().slice(0, 10).replaceAll('-', '/'),
      to: form.dateLimite.toISOString().slice(0, 10).replaceAll('-', '/'),
    };
    await Index_Write.saveObject(objectToSave, {
      autoGenerateObjectIDIfNotExist: true,
    }).wait();
    const rest = await Index_Write.search('', { hitsPerPage: 1000 });
    resetBannersData(rest.hits);
    remove(form.path);
    setIsLoading(undefined);
  };

  useEffect(() => {
    reloadData()
  }, [banner]);

  const reloadData = () => {
    Index_Write.search('', { hitsPerPage: 1000 }).then((e) => {
      resetBannersData(e.hits);
    }
    );
    setIsLoading(undefined)
  }
  useEffect(() => {
    const banners = async () => {
      let indices = await Client.listIndices();
      var names = indices.items
        .map((e) => e.name)
        .filter((e) => e.includes('categorie'));
      setBannersIndices(names);
    };

    banners();
  }, []);

  const sortDate = (arr) => {
    const sorted = arr.sort((a, b) => {
      if (a.created_at && b.created_at) return new Date(a.created_at).getTime() - new Date(b.created_at).getTime();
      if (a.created_at) return -1;
      return 1;
    });
    return sorted.filter(item => item.created_at).concat(sorted.filter(item => !item.created_at));
  };

  const sortByDate = () => {
    let filtered = sortDate(banners)
    setFilterBanners(filtered)
  }

  const clearFilter = (e) => {
    reloadData()
  }

  const sortBanners = (e) => {
    const val = e.target.value.toLowerCase();
    let filtered = banners.filter((g) =>
      g?.description?.toLowerCase()?.includes(val) ||
      g?.title?.toLowerCase()?.includes(val) ||
      g?.src?.toLowerCase()?.includes(val) ||
      g?.to?.toLowerCase()?.includes(val) ||
      g?.from?.toLowerCase()?.includes(val)
    );
    filtered.sort(sortFunction);
    setFilterBanners(filtered);
  };

  const FetchingStatus = ({ condition, text }) => {
    return (
      condition && (
        <Blockquote type="info" icon="clock">
          <label style={{ paddingLeft: '1rem' }}>{text}</label>
        </Blockquote>
      ));
  };

  return (
    <CollapsableCard type="none" canCollapse={false}>
      <Body className="banners">
        <>
        <DropDownList
            label={'Liste des catégories'}
            data={bannersIndices}
            defaultValue="prod_categories"
            style={{
              width: '22rem',
              marginRight: '10px',
              marginBottom: '10px',
            }}
            onChange={(e) => {
              setBanner(`${e.target.value}`);
            }}
          />
          <Button
            style={{
              margin: '1rem',
              marginLeft: '10px',
              backgroundColor: 'darkgray',
            }}
            onClick={updateCaching}
          >
            Mise à jour Cache
          </Button>
          <TabStrip
            animation={false}
            selected={selected}
            onSelect={handleSelect}
            keepTabsMounted={true}


          >
            <TabStripTab title="Liste des categories">
              <Blockquote type="info" icon="info">
                <label style={{ paddingLeft: '1rem' }}>
                  Mettre à jour la cache apres modification
                </label>
              </Blockquote>
              <GridToolbar>
                <span>Trier par date de creation: </span>
                <Button
                  onClick={sortByDate}
                  icon='sort-desc-sm'
                  style={{
                    background: "#2596be"
                  }}
                >
                </Button>
                <Button
                  onClick={clearFilter}
                  icon='refresh'
                >
                </Button>
                <span
                  className="k-textbox k-grid-search k-display-flex"
                  style={{
                    borderRadius: '25px',
                    width: '250px',
                    marginLeft: 'auto',
                  }}
                >
                  <input
                    autoComplete="off"
                    onChange={sortBanners}
                    placeholder="Rechercher"
                    title="Rechercher"
                    className="k-input"
                  />

                </span>
              </GridToolbar>
              {filterBanners.map((e, i) => (
                <>
                  <div style={{ marginTop: '1rem' }}>
                    <FetchingStatus
                      condition={loading === e.objectID}
                      text="Chargement"
                    />
                  </div>
                  <CategorieItemRmv
                    deleteExist={deleteBanner}
                    update={update}
                    exist
                    {...e}
                    key={Math.random()}
                  />
                </>
              ))}
            </TabStripTab>
            <TabStripTab title="Ajouter">
              <section {...getRootProps()} className="container-drag">
                <Blockquote type="info" icon="info">
                  <label style={{ paddingLeft: '1rem' }}>
                    Ajouter une bannière à la fois
                  </label>
                </Blockquote>
                <div tabIndex={0} className="dropzone">
                  <input {...getInputProps()} />
                  <i className="fas fa-inbox icon-dnd" />
                  {isDragActive ? (
                    <p>Déposer le fichier ici ...</p>
                  ) : (
                    <p>Glisser-déposer les images de bannière</p>
                  )}
                </div>
                <aside>
                  <ul />
                </aside>
              </section>
              <FetchingStatus
                condition={loading === 'categories'}
                text="Chargement"
              />
              {files.length > 0 && (
                <div
                  style={{
                    display: 'grid',
                    overflowX: 'hidden',
                  }}
                >
                  {
                    files.map((e, i) => (
                      <>
                        <FetchingStatus
                          condition={loading === e.path}
                          text="Chargement"
                        />
                        <CategorieItem
                          key={Math.random()}
                          {...e}
                          remove={remove}
                          save={save}
                        />
                      </>
                    ))}
                </div>
              )}
            </TabStripTab>
          </TabStrip>
        </>
      </Body>
    </CollapsableCard>
  );
}
